import moment, { Moment } from 'moment-timezone';

export function getLocalDate(): Moment {
  return moment().add(getUTCOffset(), 'minutes');
}

export function getUTCOffset(): number {
  return moment().utcOffset();
}

export function isFebruary29(momentDate: Moment): boolean {
  return momentDate.month() === 1 && momentDate.date() === 29;
}
